import {Component, OnDestroy, OnInit} from "@angular/core";
import {WorkflowService} from "../workflow.service";
import {Subscription} from "rxjs";

@Component({
  selector: "order-acceptance-disable",
  templateUrl: "./order-acceptance-disable-message.template.pug",
})
export class OrderAcceptanceDisabledMessageComponent implements OnInit, OnDestroy {
  private workflowStatusSubscription: Subscription;

  orderAcceptanceDisableReason: string;
  isOrderAcceptanceDisabled: boolean = false;

  constructor(private workflowService: WorkflowService) {}

  ngOnInit(): void {
    this.workflowStatusSubscription = this.workflowService.workflowStatus.subscribe(() => {
      this.updateDisplay();
    });
  }

  ngOnDestroy(): void {
    this.workflowStatusSubscription.unsubscribe();
  }

  updateDisplay(): void {
    if (this.workflowService.workflowConfig.type === "project") {
      this.isOrderAcceptanceDisabled = this.workflowService.workflowConfig.target.orderAcceptance === false &&
        this.workflowService.workflowConfig.target.orderAcceptanceDisableReason;
      this.orderAcceptanceDisableReason = this.workflowService.workflowConfig.target.orderAcceptanceDisableReason;
    }
  }
}
